module.exports = __webpack_public_path__ + "static/img/iphoneX-top.bfeebbe7.png";